<template>
  <section class="approvalListDiv">
    <viewTitle
      title="业务管理 / 审批跳过情况汇总 / 审批列表"
      :showReturn="false"
    />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <el-button
          size="small"
          type="primary"
          @click="
            $router.push({
              path: '/rhqy/service/appoint/modify',
              query: {
                type: 'add'
              }
            })
          "
          >新建审批</el-button
        >
      </div>
    </section>
    <!-- 按钮组2 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <span>办理业务: </span>
        <el-select
          class="ctl"
          v-model="params.status"
          placeholder="请选择"
          @change="changeStatus"
        >
          <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in statusOption"
            :key="index"
          ></el-option>
        </el-select>
        <el-input
          class="ctl"
          style="width: 20% !important;"
          clearable
          placeholder="输入要搜索的建议内容"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
        <el-button type="primary" @click="refreshData" size="small">
          刷新数据
        </el-button>
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        style="position: absolute;width: 100%"
        :height="isOverSize ? maxSize : 'auto'"
        :class="{ auto: !isOverSize }"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column prop="title" label="办理业务"> </el-table-column>
        <el-table-column prop="name" label="运输单位"> </el-table-column>
        <el-table-column prop="phone" label="车牌号"> </el-table-column>
        <el-table-column prop="phone" label="车型"> </el-table-column>
        <el-table-column prop="phone" label="保证人"> </el-table-column>
        <el-table-column prop="phone" label="创建时间"> </el-table-column>
        <el-table-column prop="phone" label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item @click.native.stop="viewDetail(scope.row)"
                    >编辑</el-dropdown-item
                  >
                  <el-dropdown-item @click.native.stop="del(scope.row)"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <div class="page-wrap">
      <pagi
        :page="page"
        :pageSize="pageSize"
        :count="count"
        @pageChange="pageChange"
      ></pagi>
    </div>

    <el-dialog
      :visible.sync="dialogParams.show"
      width="30%"
      :show-close="dialogParams.title === '确认提醒'"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div style="font-size: 18px;">
          <i
            class="el-icon-success"
            style="color: #2acdcf;"
            v-if="dialogParams.title === '操作成功'"
          ></i>
          {{ dialogParams.title }}
        </div>
      </template>
      <div>
        <div v-html="dialogParams.content"></div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="dialogParams.title === '确认提醒'"
      >
        <el-button @click="dialogParams.show = false" size="small">
          取 消
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="confirmDel"
          v-loading.fullscreen.lock="fullscreenLoading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
// import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";

export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      page: 0,
      pageSize: 50,
      count: 0, // 表格总数
      params: {
        keyword: "", // 关键字搜索
        status: "" // 状态
      },
      dialogParams: {
        show: false,
        title: "",
        content: ""
      },
      fullscreenLoading: false,
      maxSize: 0,
      tableData: [], // 表格数据
      // dialogData: {
      //   show: false,
      //   type: "",
      //   label: ""
      // },
      // reason: "", // 回复内容
      // editComplainId: "", // 删除的id
      statusOption: [
        "全部",
        "成品提货",
        "原料送货",
        "废品回收",
        "废品送货",
        "跨厂调拨提货",
        "跨厂调拨送货",
        "其它"
      ]
    };
  },

  components: {
    pagi,
    viewTitle
  },

  computed: {
    isOverSize() {
      return this.tableData.length > 3;
    }
  },

  mounted() {
    setTimeout(() => {
      this.resizeTableHeight();
      window.addEventListener(
        "resize",
        e => {
          //  初始化表格合适高度
          this.resizeTableHeight();
          console.log(e);
        },
        false
      );
    }, 500);
    this.getList();
  },

  async activated() {},

  created() {},

  methods: {
    // 切换页码
    pageChange(page) {
      this.page = page;
      if (page == 1) {
        this.tableData = [
          {
            title: "标题1",
            name: "张三",
            phone: "13800138000"
          },
          {
            title: "标题2",
            name: "张四",
            phone: "13800138001"
          },
          {
            title: "标题3",
            name: "张五",
            phone: "13800138002"
          },
          {
            title: "标题1",
            name: "张三",
            phone: "13800138000"
          },
          {
            title: "标题2",
            name: "张四",
            phone: "13800138001"
          },
          {
            title: "标题3",
            name: "张五",
            phone: "13800138002"
          },
          {
            title: "标题1",
            name: "张三",
            phone: "13800138000"
          },
          {
            title: "标题2",
            name: "张四",
            phone: "13800138001"
          },
          {
            title: "标题3",
            name: "张五",
            phone: "13800138002"
          },
          {
            title: "标题1",
            name: "张三",
            phone: "13800138000"
          },
          {
            title: "标题2",
            name: "张四",
            phone: "13800138001"
          },
          {
            title: "标题3",
            name: "张五",
            phone: "13800138002"
          }
        ];
      } else {
        this.tableData = [
          {
            title: "第二页-标题1",
            name: "张六",
            phone: "13800138003"
          },
          {
            title: "第二页-标题2",
            name: "张七",
            phone: "13800138004"
          },
          {
            title: "第二页-标题3",
            name: "张八",
            phone: "13800138005"
          }
        ];
      }
    },

    // 关键字搜索
    changeKeyword(val) {
      console.log(val);
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_unit_class",
        data: {
          page: this.page,
          state: "",
          keyword: ""
        }
      });
      console.log(dataObj.data.data);
      this.page++;
      this.tableData = dataObj.data.data.data;
      this.count = dataObj.data.data.total;
    },

    // 修改状态
    changeStatus(val) {
      console.log(val);
    },

    // 刷新数据
    refreshData() {
      console.log("刷新数据");
    },

    // 查看详情
    viewDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/rhqy/service/appoint/modify",
        query: {
          type: "edit"
        }
      });
    },

    // 删除
    del() {
      this.dialogParams.content =
        '确认要删除“<span class="color67">粤C80390</span>”的审批信息吗？删除后不可恢复！';
      this.dialogParams.title = "确认提醒";
      this.dialogParams.show = true;
    },

    // 确认删除
    confirmDel() {
      this.fullscreenLoading = true;
      this.dialogParams.show = true;
      setTimeout(() => {
        this.fullscreenLoading = false;
        this.dialogParams.content =
          '已删除“<span class="color67">粤C80390</span>”的审批信息。';
        this.dialogParams.title = "操作成功";
        setTimeout(() => {
          this.dialogParams.show = false;
        }, 3000);
      }, 3000);
    },

    // 重置高度
    resizeTableHeight() {
      const BANNER_HEIGHT = 25; // 头部导航高度
      const PADDING = 24; // padding
      const ETC = 260; // 头部 和 底部导航高度
      var offsetHeihgt = window.innerHeight - BANNER_HEIGHT - PADDING * 2;
      this.maxSize = offsetHeihgt - ETC;
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.approvalListDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 13px;
    .ctl {
      display: inline-block;
      width: 10% !important;
      margin: 0 35px 0px 0px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 169px);
    position: relative;
  }
}
</style>
